














































































































































































import { Vue, Component, Prop } from 'vue-property-decorator'
import { User, DictParam, DictRequest, DictFilter, DictOptions, LoginForm } from '@/types'
import { EPLModule } from '../store/eplmodule'

@Component({
  name: 'AppBar',
  components: {
    Messages: () =>
      import(/* webpackChunkName: "Messages" */ '@/components/Messages.vue')
  }
})
export default class AppBar extends Vue {
  @Prop() authTimer!: number
  @Prop() showBar!: boolean
  @Prop() colorNfc!: string
  @Prop() nfc!: boolean

  drawerMenu = false
  drawerMsgs = false
  idx = -1
  userRole = ''
  barKey = 0
  logo = ''

  async mounted () {
    EPLModule.fetchWhoInfo()
      .then((data: {companyname: string, logo: string}) => {
        if (data.companyname !== undefined) {
          document.title = `${data.companyname} ЭПЛ`
        }
        if (data.logo !== undefined) {
          this.logo = data.logo
        }
      })
    setTimeout(() => {
      // this.idx = EPLModule.DictIdx('Events')
      EPLModule.dicts.forEach((d, i) => {
        if (d.name === 'Events') this.idx = i
      })
    }, 1000)
    const idxR = EPLModule.DictIdx('Roles')
    const pr = {} as DictParam
    pr.idx = idxR
    pr.request = {} as DictRequest
    pr.request.options = { page: 1, itemsPerPage: -1 }
    pr.request.filter = []
    const fr = {} as DictFilter
    fr.field = 'id'
    fr.condition = `${this.user.roleid}`
    fr.operator = '='
    pr.request.filter.push(fr)
    EPLModule.fetchDictData(pr)
      .then(() => {
        this.userRole = EPLModule.dicts[idxR].rows[0].rolename
      })
  }

  private clickUser () {
    // const s = ''
    // const t = s.match(/T=([А-Яа-я\s]+),/)
    // const sn = s.match(/SN=([А-Яа-я\s]+),/)
    // const g = s.match(/G=([А-Яа-я\s]+),/)
    // let tt = ''
    // if (t !== null) {
    //   tt = t[1]
    // }
    // console.log(tt, sn, g)
  }

  get messagesCount (): number {
    if (EPLModule.dicts[this.idx] === undefined) {
      return 0
    }
    return EPLModule.dicts[this.idx].rowsCount
  }

  get user (): User {
    return EPLModule.user
  }

  get calendar (): boolean {
    const idx = EPLModule.DictIdx('Calendar')
    return !EPLModule.dicts[idx].locked.read
  }

  get EPLjournal (): boolean {
    const idx = EPLModule.DictIdx('EPLjournal')
    return !EPLModule.dicts[idx].locked.read
  }

  get loading (): number {
    return EPLModule.loading
  }

  private logout () {
    if (confirm('Выход?')) EPLModule.ClearAuth()
  }

  private DOMnodes () {
    console.log('nodes', document.getElementsByTagName('*').length)
  }
}
